/**
 * @typedef {import('./lib/create-plugin.js').Options} Options
 */

export {default} from './lib/svg.js'
